"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentVersionSubscriptionImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing DocumentVersionSubscription operations. */
var DocumentVersionSubscriptionImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class DocumentVersionSubscription class.
   * @param client Reference to the service client
   */
  function DocumentVersionSubscriptionImpl(client) {
    (0, _classCallCheck2["default"])(this, DocumentVersionSubscriptionImpl);
    this.client = client;
  }
  /**
   *  (Auth: Authorize)
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(DocumentVersionSubscriptionImpl, [{
    key: "getSubscriptionsForUser",
    value: function getSubscriptionsForUser(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSubscriptionsForUserOperationSpec);
    }
    /**
     * @param portalId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "createOrUpdate",
    value: function createOrUpdate(portalId, body, options) {
      var operationArguments = {
        portalId: portalId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, createOrUpdateOperationSpec);
    }
    /**
     * @param portalId
     * @param email
     * @param options The options parameters.
     */

  }, {
    key: "getSubscriptionsForEmail",
    value: function getSubscriptionsForEmail(portalId, email, options) {
      var operationArguments = {
        portalId: portalId,
        email: email,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSubscriptionsForEmailOperationSpec);
    }
    /**
     * @param portalId
     * @param email
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "update",
    value: function update(portalId, email, body, options) {
      var operationArguments = {
        portalId: portalId,
        email: email,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, updateOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getSubscriptionsForDocument",
    value: function getSubscriptionsForDocument(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSubscriptionsForDocumentOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param hiveId
     * @param fullName
     * @param options The options parameters.
     */

  }, {
    key: "deleteByCurrentUser",
    value: function deleteByCurrentUser(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteByCurrentUserOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionId
     * @param options The options parameters.
     */

  }, {
    key: "deleteDocumentVersionSubscription",
    value: function deleteDocumentVersionSubscription(portalId, subscriptionId, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionId: subscriptionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteDocumentVersionSubscriptionOperationSpec);
    }
    /**
     * @param portalId
     * @param subscriptionId
     * @param email
     * @param options The options parameters.
     */

  }, {
    key: "deleteDocumentVersionSubscriptionWithEmail",
    value: function deleteDocumentVersionSubscriptionWithEmail(portalId, subscriptionId, email, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionId: subscriptionId,
        email: email,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteDocumentVersionSubscriptionWithEmailOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getNextDocumentVersionFullName",
    value: function getNextDocumentVersionFullName(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getNextDocumentVersionFullNameOperationSpec);
    }
  }]);
  return DocumentVersionSubscriptionImpl;
}(); // Operation Specifications


exports.DocumentVersionSubscriptionImpl = DocumentVersionSubscriptionImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getSubscriptionsForUserOperationSpec = {
  path: "/api/Portals({portalId})/User/DocumentVersionSubscriptions",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentVersionSubscriptionInfo"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var createOrUpdateOperationSpec = {
  path: "/api/Portals({portalId})/User/DocumentVersionSubscriptions",
  httpMethod: "PUT",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentVersionSubscriptionInfo
    },
    400: {}
  },
  requestBody: Parameters.body18,
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var getSubscriptionsForEmailOperationSpec = {
  path: "/api/Portals({portalId})/EmailAccounts({email})/DocumentVersionSubscriptions",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentVersionSubscriptionInfo"
            }
          }
        }
      }
    }
  },
  queryParameters: [Parameters.ticket],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.email],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var updateOperationSpec = {
  path: "/api/Portals({portalId})/EmailAccounts({email})/DocumentVersionSubscriptions",
  httpMethod: "PUT",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentVersionSubscriptionInfo
    }
  },
  requestBody: Parameters.body19,
  queryParameters: [Parameters.ticket],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.email],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var getSubscriptionsForDocumentOperationSpec = {
  path: "/api/Portals({portalId})/User/DocumentVersionSubscriptions/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentVersionSubscriptionInfo"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var deleteByCurrentUserOperationSpec = {
  path: "/api/Portals({portalId})/User/DocumentVersionSubscriptions/{hiveId}/{fullName}",
  httpMethod: "DELETE",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  serializer: serializer
};
var deleteDocumentVersionSubscriptionOperationSpec = {
  path: "/api/Portals({portalId})/User/DocumentVersionSubscriptions/{subscriptionId}",
  httpMethod: "DELETE",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionId],
  serializer: serializer
};
var deleteDocumentVersionSubscriptionWithEmailOperationSpec = {
  path: "/api/Portals({portalId})/EmailAccounts({email})/DocumentVersionSubscriptions/{subscriptionId}",
  httpMethod: "DELETE",
  responses: {
    200: {}
  },
  queryParameters: [Parameters.ticket],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.email, Parameters.subscriptionId],
  serializer: serializer
};
var getNextDocumentVersionFullNameOperationSpec = {
  path: "/api/Portals({portalId})/NextDocumentVersion/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "String"
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept1],
  serializer: serializer
};